module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_c('div', {
    class: [_vm.prefixCls + '-bar']
  }, [_c('div', {
    class: [_vm.prefixCls + '-nav-container']
  }, [_c('div', {
    class: [_vm.prefixCls + '-nav-wrap']
  }, [_c('div', {
    class: [_vm.prefixCls + '-nav-scroll']
  }, [_c('div', {
    ref: "nav",
    class: [_vm.prefixCls + '-nav']
  }, [_c('div', {
    class: _vm.barClasses,
    style: (_vm.barStyle)
  }), _vm._v(" "), _vm._l((_vm.navList), function(item, index) {
    return _c('div', {
      class: _vm.tabCls(item),
      on: {
        "click": function($event) {
          _vm.handleChange(index)
        }
      }
    }, [(item.icon !== '') ? _c('Icon', {
      attrs: {
        "type": item.icon
      }
    }) : _vm._e(), _vm._v(" "), (item.labelType === 'function') ? _c('Render', {
      attrs: {
        "render": item.label
      }
    }) : [_vm._v(_vm._s(item.label))], _vm._v(" "), (_vm.showClose(item)) ? _c('Icon', {
      attrs: {
        "type": "ios-close-empty"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.handleRemove(index)
        }
      }
    }) : _vm._e()], 2)
  })], 2), _vm._v(" "), (_vm.showSlot) ? _c('div', {
    class: [_vm.prefixCls + '-nav-right']
  }, [_vm._t("extra")], 2) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    class: _vm.contentClasses,
    style: (_vm.contentStyle)
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6692db2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/tabs/tabs.vue
// module id = 645
// module chunks = 1